module.exports = __webpack_public_path__ + "static/media/angelus.59249eaa.jpg";